"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocal = isLocal;
exports.redirectToLogin = redirectToLogin;
exports.parseDate = parseDate;
exports.formatDateForServer = formatDateForServer;
exports.now = now;
exports.todayMoment = todayMoment;
exports.isEmpty = isEmpty;
exports.concatIfNotEmpty = concatIfNotEmpty;
exports.isNotEmpty = isNotEmpty;
exports.getParameterByName = getParameterByName;
exports.getClassicUrl = getClassicUrl;
exports.redirectToClassic = redirectToClassic;
exports.redirectToTSBDemoForm = redirectToTSBDemoForm;
exports.redirectTo = redirectTo;
const constants_1 = require("./constants");
const moment = require('moment');
function isLocal() {
    return window.location.href.indexOf('http://localhost:') === 0;
}
function redirectToLogin(force, redirectUrl, returnForSignup) {
    if (constants_1.SHOW_LOGIN_ERROR_PAGE && !force) {
        window.history.pushState(null, 'Login Error', '/login-error');
        return;
    }
    redirectUrl = redirectUrl || window.location.href;
    if (returnForSignup) {
        window.location.assign(`${constants_1.COGSWORTH_URL}login?client_id=${constants_1.CLIENT_ID}&redirect_uri=${redirectUrl}&signup_uri=${constants_1.SIGNUP_URL}`);
        return;
    }
    window.location.assign(`${constants_1.COGSWORTH_URL}login?client_id=${constants_1.CLIENT_ID}&redirect_uri=${redirectUrl}`);
}
function parseDate(date, format) {
    return date && moment(date, format || 'YYYY-MM-DD');
}
function formatDateForServer(moment) {
    return moment && moment.format('YYYY-MM-DD');
}
function now() {
    return moment();
}
function todayMoment() {
    return moment();
}
function isEmpty(value) {
    return !value || value.trim() === '';
}
function concatIfNotEmpty(base, stringToAdd, delimiter) {
    if (isEmpty(base))
        return stringToAdd;
    if (isEmpty(stringToAdd))
        return base;
    if (isEmpty(delimiter))
        return base + ' ' + stringToAdd;
    return base + delimiter + ' ' + stringToAdd;
}
function isNotEmpty(value) {
    return !isEmpty(value);
}
function getParameterByName(url, name) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function getClassicUrl(pathname) {
    return `${constants_1.TEAMSNAP_URL}${pathname}`;
}
function redirectToClassic(pathname) {
    window.location.href = getClassicUrl(pathname);
}
function redirectToTSBDemoForm() {
    window.location.href = 'https://teamsnap.com/for-business/demo';
}
function redirectTo(url) {
    if (!url)
        return;
    window.location.href = url;
}
